import {
  Paper,
  styled,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  InputBase,
  alpha,
  MenuItem,
  Select,
  FormControl,
} from "@mui/material";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
export const StyledPaper = styled(Paper)(({ theme }) => ({
  height: "100%",
  padding: "5px 5px 5px 5px",
  background: "none",
  boxShadow: "none",
  borderRadius: "none",
  overflow: "hidden",
  fontSize: "13px",
}));
export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#e9e9e9",
    color: theme.palette.common.black,
    fontSize: 12,
    zIndex: 11,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
    zIndex: 11,
  },
}));

export const StyledTableCell4 = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#e9e9e9",
    color: theme.palette.common.black,
    fontSize: 12,
    zIndex: 0,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
  },
}));
export const StyledTableCell2 = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.root}`]: {
    backgroundColor: "#FFFF",
    color: theme.palette.common.black,
    fontSize: 11,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
  },
}));
export const StyledTableCell3 = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.root}`]: {
    backgroundColor: "#FFFF",
    color: theme.palette.common.black,
    fontSize: 11,
    border: "1px solid #e8e8e8",
    zIndex: 0,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
    zIndex: 0,
  },
}));

export const StyledTableCell5 = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.root}`]: {
    backgroundColor: "#FFFF",
    color: theme.palette.common.black,
    fontSize: 12,
    border: "1px solid #e8e8e8",
    zIndex: 0,
    textTransform: "capitalize",

  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 12,
    zIndex: 0,
    textTransform: "capitalize",

  },
}));
export const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  height: "100%",
  width: "100%",
  scrollbarWidth: "thin",
  "&::-webkit-scrollbar": {
    width: "10px",
  },
  "&::-webkit-scrollbar-track": {
    background: "#f1f1f1",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#888",
    borderRadius: "10px",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    background: "#555",
  },
}));
export const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(1),
    width: "auto",
  },
}));

export const SearchIconWrapper = styled("div")(() => ({
  height: "90%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginLeft: "-10px",
  color: "#919191",
}));

export const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  width: "100%",
  "& .MuiInputBase-input": {
    paddingLeft: `calc(0.5em + ${theme.spacing(0)})`,
  },
}));

export const StyledTable = styled(Table)(({ theme }) => ({}));
export const StyledTableHead = styled(TableHead)(({ theme }) => ({}));
export const StyledTableBody = styled(TableBody)(({ theme }) => ({}));
export const StyledTableRow = styled(TableRow)(({ theme }) => ({}));


// Missed call sidebar supervisor styled component //
export const MissedCallTableHead = styled(TableHead)(({ theme }) => ({
  position: "sticky",
  top: 0,
  zIndex: 10,
  backgroundColor: "#E9E9E9",

  "& .MuiTableCell-root": {
    "&:nth-of-type(1)": {
      position: "sticky",
      left: 0,
      zIndex: 8,
      backgroundColor: "#E9E9E9",
    },
  },
}));

// In report Set Page styled component //
export const FormControls = styled(FormControl)(({ theme }) => ({
  minWidth: "70px",
  width: "3%",
  backgroundColor: "#fff",
  borderRadius: "5px",
  border: "1px solid #fff",
  boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06)",
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#fff",
    },
    "&:hover fieldset": {
      borderColor: "#fff",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#fff",
      boxShadow: "none",
    },
  },
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
}));
export const Selects = styled(Select)(() => ({
  fontSize: "12px",
  "& .MuiSelect-select": {
    paddingTop: "4px",
    paddingBottom: "4px",
    paddingRight: "12px",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "transparent",
  },
}));
export const MenuItems = styled(MenuItem)(() => ({
  fontSize: "12px",
}));
// In report Set Page styled component //
